module.exports = __webpack_public_path__ + "static/media/publico.939894bf.webp";